<script lang="ts" setup>
import type { ButtonProps } from "@nuxt/ui";
import type { Ref } from "vue";
import { computed } from "vue";
import { useNuxtApp } from "#app";

const { $darkMode } = useNuxtApp() as unknown as {
  $darkMode: { isDark: Ref<boolean>; toggleDarkMode: () => void } | undefined;
};

type Icons = "i-ph-sun" | "i-ph-moon";
const icon = computed<Icons>(() =>
  $darkMode?.isDark.value ? "i-ph-moon" : "i-ph-sun"
);
const variant = computed<ButtonProps["variant"]>(() =>
  $darkMode?.isDark.value ? "outline" : "subtle"
);

function toggleDarkMode() {
  $darkMode?.toggleDarkMode();
}
</script>
<template>
  <ClientOnly>
    <UButton
      color="primary"
      :variant="variant"
      size="lg"
      :leading-icon="icon"
      aria-label="Toggle dark mode"
      class="rounded-lg"
      @click="toggleDarkMode"
    />
  </ClientOnly>
</template>
